import { Grid, makeStyles, TextField } from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import { CreateMeetingContext } from '../../../services/create-meeting/create-meeting.context';

const useStyles = makeStyles((theme) => {
  return {
    title: {
      marginBottom: 3,
    },
    textField: {
      marginBottom: theme.spacing(0.5),
      marginTop: theme.spacing(0.5),
    },
  };
});

export const TitleDescr = ({ id }) => {
  const { states } = useContext(CreateMeetingContext);
  const classes = useStyles();
  const { title, setTitle, description, setDescription, descRef, titleRef } =
    states;

  const handleChangeTitle = (value) => (event) => {
    setTitle({ ...title, [value]: event.target.value, error: null });
    !id && localStorage.setItem('title', event.target.value);
  };

  useEffect(() => {
    if (titleRef) {
      titleRef.current.dir = 'auto';
    }

    if (descRef) {
      descRef.current.dir = 'auto';
    }
  }, []);

  useEffect(() => {
    if (!id) {
      setTitle(
        localStorage.getItem('title')
          ? { value: localStorage.getItem('title'), error: false }
          : { value: '', error: false }
      );
      setDescription(
        localStorage.getItem('description')
          ? { value: localStorage.getItem('description'), error: false }
          : { value: '', error: false }
      );
    }
  }, [id]);

  return (
    <Grid container direction='row' justifyContent='center'>
      <Grid item xs={12} sm={12}>
        <TextField
          label='Title'
          inputProps={{ maxLength: 50 }}
          helperText={`${title.value.length}/${50}`}
          onChange={handleChangeTitle('value')}
          className={classes.title}
          inputRef={titleRef}
          size='small'
          variant='outlined'
          value={title.value}
          name='title'
          error={title.error}
          fullWidth
          required
        />

        <TextField
          label='Description'
          className={classes.textField}
          size='small'
          variant='outlined'
          value={description.value}
          name='description'
          error={description.error}
          inputRef={descRef}
          onChange={(e) => {
            setDescription({ value: e.target.value, error: false });
            !id && localStorage.setItem('description', e.target.value);
          }}
          multiline
          rows={5}
          fullWidth
          required
        />
      </Grid>
    </Grid>
  );
};
